import { render, staticRenderFns } from "./takeCharge.vue?vue&type=template&id=bda364ac&scoped=true"
import script from "./takeCharge.vue?vue&type=script&lang=js"
export * from "./takeCharge.vue?vue&type=script&lang=js"
import style0 from "./takeCharge.vue?vue&type=style&index=0&id=bda364ac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda364ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bda364ac')) {
      api.createRecord('bda364ac', component.options)
    } else {
      api.reload('bda364ac', component.options)
    }
    module.hot.accept("./takeCharge.vue?vue&type=template&id=bda364ac&scoped=true", function () {
      api.rerender('bda364ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/mdInfo/components/takeCharge.vue"
export default component.exports